import { sendGoogleEvent, sendRequest } from '@html/_common/utils';

export default function AMCommonGenericTopBannerES6($banner) {
  const EVENT_CATEGORY = 'Generic Banner';
  const EVENT_ACTION_IMPRESSION = 'Impression';
  const EVENT_ACTION_CLICK = 'Click';

  const CLASS_DISMISS_ELEMENT = 'js-am-common-generic-top-banner__dismiss';
  const SELECTOR_DISMISS_ELEMENT = `.${CLASS_DISMISS_ELEMENT}`;

  const onClickBanner = (event) => {
    const hasClickedDismissElement = $(event.target).hasClass(CLASS_DISMISS_ELEMENT);
    if (hasClickedDismissElement) {
      return false;
    }

    sendGoogleEvent(
      EVENT_CATEGORY,
      EVENT_ACTION_CLICK,
      window.location.pathname,
    );

    return true;
  };

  const onClickDismiss = () => {
    const bannerId = $banner.data('id');

    sendRequest('/api/banner/dismiss', {
      id: bannerId,
    }, () => {
      $banner.remove();
    });
  };

  this.initiate = () => {
    sendGoogleEvent(
      EVENT_CATEGORY,
      EVENT_ACTION_IMPRESSION,
      window.location.pathname,
      {
        nonInteraction: true,
      },
    );

    const hasClickableLink = !!$banner.attr('href');
    if (hasClickableLink) {
      $banner.on('click', onClickBanner);
    }

    const $dismissElement = $banner.find(SELECTOR_DISMISS_ELEMENT);
    if ($dismissElement.length) {
      $dismissElement.on('click', onClickDismiss);
    }
  };
}
